module.exports = __webpack_public_path__ + "img/plug-cloud.a519eee3.svg";